import React, { useState } from "react";
import {
  CognitoIdentityProviderClient,
  SignUpCommand,
  ConfirmSignUpCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import config from "../../config.json";

export const cognitoClient = new CognitoIdentityProviderClient({
  region: process.env.REACT_APP_REGION ? process.env.REACT_APP_REGION : 'ap-south-1',
});

// TODO: Move this into feature/auth folder and update the component and UI as per latest theme
export const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const params = {
      ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID ? process.env.REACT_APP_COGNITO_CLIENT_ID : 'r3a1kq4e4qp726c8fprl9fp0b',
      Username: "sandeep3",
      Password: password,
      UserAttributes: [
        {
          Name: "email",
          Value: email,
        },
      ],
    };
    try {
      const command = new SignUpCommand(params);
      const response = await cognitoClient.send(command);
      //const response = null;
      console.log("Sign up success: ", response);
      console.log("Signup:", { email, password });
      confirmSignUp(e);
      return response;
    } catch (error) {
      console.error("Error signing up: ", error);
      throw error;
    }
    //console.log('Signup:', { email, password });
  };
  const confirmSignUp = async (e) => {
    e.preventDefault();
    const params = {
      ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID ? process.env.REACT_APP_COGNITO_CLIENT_ID : 'r3a1kq4e4qp726c8fprl9fp0b',
      Username: "sandeep3",
      ConfirmationCode: "392103",
    };
    try {
      const command = new ConfirmSignUpCommand(params);
      await cognitoClient.send(command);
      console.log("User confirmed successfully");
      return true;
    } catch (error) {
      console.error("Error confirming sign up: ", error);
      throw error;
    }
  };

  return (
    <div
      className="container d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div
        className="card shadow-sm"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <div className="card-header text-center bg-success text-white">
          <h4>Sign Up</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Email:</label>
              <input
                type="text"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Password:</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-success w-100">
              Sign Up
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
